<template>
  <div :class="$style.balance">
    <Balance />

    <div
      v-if="info?.blockDeposit === 0"
      :class="$style.refill"
    >
      <AppButton
        :theme="ThemesEnumButton.LIGHT"
        @click="openRefillCashModal()"
      >
        {{ $t('home.refillCash') }}
      </AppButton>
    </div>
  </div>
  <div :class="$style.limit">
    <Limit />
  </div>
  <div :class="$style.linkButtons">
    <ButtonLink
      :class="$style.buttonLink"
      :to="{ ...(isKYCCompleted && ({name: RouteNamesEnum.REFILL})) }"
      :theme="ThemesEnum.BLUE"
      icon="replenish"
      @click="refillClickHandler"
    >
      {{ $t("home.topUpAnAccount") }}
    </ButtonLink>
    <ButtonLink
      :class="$style.buttonLink"
      :to="{ ...(isKYCCompleted && ({name: RouteNamesEnum.WITHDRAWALS}))}"
      icon="payment-of-request"
      @click="paymentRequestClickHandler"
    >
      {{ $t("home.paymentRequest") }}
    </ButtonLink>
  </div>
  <Profit v-if="isAccessAllowed" />
</template>

<script setup>
import AppButton, { ThemesEnum as ThemesEnumButton } from '@/components/AppButton.vue';
import Balance from '@/components/Balance.vue';
import ButtonLink, { ThemesEnum } from '@/components/ButtonLink.vue';
import Limit from '@/components/Limit.vue';
import Profit from '@/components/Profit.vue';
import RouteNamesEnum from '@/constant/RouteNamesEnum';
import { useKYC } from '@/hooks/useKYC';
import MetricTracker, { MetricCatEnum } from '@/services/MetricTrackers/MetricTracker';
import { isAccessAllowed } from '@/store/featureFlags';
import { isKYCCompleted, info } from '@/store/mainInfo';
import { ModalsEnum, openModal } from '@/store/modals';

const handleKYCAndTrack = async (buttonText) => {
  if (isKYCCompleted.value) {
    MetricTracker.clickButton({
      cat: MetricCatEnum.COMMON,
      buttonText,
    });
  } else {
    await useKYC();
  }
};

const refillClickHandler = () => handleKYCAndTrack('top_up');
const paymentRequestClickHandler = () => handleKYCAndTrack('payment_request');

const openRefillCashModal = async () => {
  if (isKYCCompleted.value) {
    openModal(ModalsEnum.REFILL_CASH);
  } else {
    await useKYC();
  }
};
</script>

<style lang="scss" module>
.balance {
  margin-bottom: 21px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.refill {
  @media (max-width: 768px) {
    width: 100%;
  }
}

.limit {
  margin-bottom: 20px;
}

.linkButtons {
  display: flex;
  margin-bottom: 20px;
}

.buttonLink {
  flex-grow: 1;
  flex-basis: 0;

  &:first-child {
    margin-right: 20px;
  }
}
</style>
